import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { API_BASE } from '../../config/api';
import { FaArrowRight } from 'react-icons/fa';
import './AdminSolutionsEdit.css';

const defaultForm = {
  subtitle_text: 'مشكلتك، ولها حل',
  main_heading: 'ماذا تستفيدين من العمل معي؟',
  card1_title: 'فهم الثغرات',
  card1_desc:
    'أفهم مشكلة بحثك عن قرب، وأحدد لك الثغرات بدقة متناهية لتتجاوزي مرحلة الضياع.',
  card2_title: 'التوجيه الواضح',
  card2_desc:
    'أقدم لك توجيهًا أكاديميًا منهجيًا بدلاً من التخبط العشوائي، لتعرفي طريقك بوضوح.',
  card3_title: 'بناء الثقة',
  card3_desc:
    'لا نكتفي بإنهاء البحث، بل نبني لك ثقة أكاديمية قوية بنفسك وبما كتبتِه.',
  cta_text: 'تعرفي على خدماتي',
};

const SOLUTIONS_ID = 1;

const AdminSolutionsEdit = () => {
  const navigate = useNavigate();

  const getAuthHeaders = () => {
    const token = localStorage.getItem('adminToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState(defaultForm);

  useEffect(() => {
    axios
      .get(`${API_BASE}/api/admin/solutions`, { headers: getAuthHeaders() })
      .then((res) => {
        const s = res.data?.solutions;
        if (!s) return;
        setForm({
          subtitle_text: s.subtitle_text ?? defaultForm.subtitle_text,
          main_heading: s.main_heading ?? defaultForm.main_heading,
          card1_title: s.card1_title ?? defaultForm.card1_title,
          card1_desc: s.card1_desc ?? defaultForm.card1_desc,
          card2_title: s.card2_title ?? defaultForm.card2_title,
          card2_desc: s.card2_desc ?? defaultForm.card2_desc,
          card3_title: s.card3_title ?? defaultForm.card3_title,
          card3_desc: s.card3_desc ?? defaultForm.card3_desc,
          cta_text: s.cta_text ?? defaultForm.cta_text,
        });
      })
      .catch((err) => {
        console.error('Failed to load solutions:', err);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(
        `${API_BASE}/api/admin/solutions`,
        { id: SOLUTIONS_ID, ...form },
        { headers: getAuthHeaders() }
      );
      alert('تم حفظ قسم الحلول بنجاح');
      navigate('/admin');
    } catch (err) {
      alert(err.response?.data?.error || 'فشل حفظ قسم الحلول');
    } finally {
      setSaving(false);
    }
  };

  const cardTitleOrder = useMemo(() => ['card1', 'card2', 'card3'], []);

  if (loading) return <div className="admin-loading">جاري التحميل...</div>;

  return (
    <div className="admin-solutions-edit" dir="rtl">
      <div className="admin-solutions-edit-header">
        <Link to="/admin" className="back-link">
          <FaArrowRight /> العودة للصفحة الرئيسية
        </Link>
        <h1 className="admin-page-title">تعديل قسم الحلول</h1>
      </div>

      <form onSubmit={handleSubmit} className="admin-solutions-form">
        <div className="form-row">
          <label>عنوان صغير (Subtitle)</label>
          <input
            type="text"
            value={form.subtitle_text}
            onChange={(e) => handleChange('subtitle_text', e.target.value)}
            className="form-input"
            required
          />
        </div>

        <div className="form-row">
          <label>العنوان الرئيسي</label>
          <input
            type="text"
            value={form.main_heading}
            onChange={(e) => handleChange('main_heading', e.target.value)}
            className="form-input"
            required
          />
        </div>

        {cardTitleOrder.map((c, idx) => (
          <div key={c} className="admin-solutions-card-edit">
            <h2 className="admin-solutions-card-title">
              تعديل البطاقة {idx + 1}
            </h2>

            <div className="form-row">
              <label>عنوان البطاقة</label>
              <input
                type="text"
                value={form[`${c}_title`]}
                onChange={(e) =>
                  handleChange(`${c}_title`, e.target.value)
                }
                className="form-input"
                required
              />
            </div>

            <div className="form-row">
              <label>وصف البطاقة</label>
              <textarea
                value={form[`${c}_desc`]}
                onChange={(e) =>
                  handleChange(`${c}_desc`, e.target.value)
                }
                className="form-input"
                rows={4}
                required
              />
            </div>
          </div>
        ))}

        <div className="form-row">
          <label>نص زر CTA</label>
          <input
            type="text"
            value={form.cta_text}
            onChange={(e) => handleChange('cta_text', e.target.value)}
            className="form-input"
            required
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="admin-btn-primary" disabled={saving}>
            {saving ? 'جارٍ الحفظ...' : 'حفظ'}
          </button>
          <button
            type="button"
            className="admin-btn-secondary"
            onClick={() => navigate('/admin')}
            disabled={saving}
          >
            إلغاء
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminSolutionsEdit;

